import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { productApiActions } from "../../../ShopStore/store";
import ProductDesign from "../../ShareComp/ProductDesign/ProductDesign";
import { productActions } from "../../../ShopStore/store";

const FeaturedPro = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(productApiActions.featured());
  }, [dispatch]);
  const featuredProducts = useSelector(
    (state) => state.productApiData.featuredProducts
  );
  const addProduct = (product) => {
    dispatch(productActions.addToCartProduct(product));
  };
  return (
    <>
      <section className="featured-products">
        <div className="new-products-tab-wrapper">
          {featuredProducts.map((pro) => {
            return (
              <>
                <section className="product-design" key={pro.id}>
                  <div className="product-design-wrapper">
                    <img src={pro.image} alt={pro.title} />
                    <h6>{pro.title}</h6>
                    <p>${pro.price}</p>
                    <button
                      className="btn-primary"
                      onClick={() => addProduct(pro)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </section>
              </>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default FeaturedPro;
